module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_11-159559322c0c4cc83bd0822dba035fd2.png";